import React from 'react';
import styled from 'styled-components';
import SpanPrice from '../common/price/SpanPrice'
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import * as F from '../../lib/util/CommonFunctions';
import { Link } from 'react-router-dom';

const SearchBrandProdItemBlock = styled.div`
    /* float: left;
    width: 20%;
    padding-left: 30px; */
    
    ${isMobileOnly&&"width:44vw; margin-bottom: 1rem"};
`;

const SearchBrandProdItemPBlock = styled.p`
    margin-bottom: 20px;
    overflow: hidden;
    cursor: pointer;
    ${!isMobileOnly&&"line-height : 272px"};
`;

const SearchBrandProdItemImg = styled.img`
    border-radius: 4px;
    cursor: pointer;
    ${isMobileOnly&&`
      // width:48vw;
      // height:175px;
        height: 44vw;
    `};
    ${!isMobileOnly&&`
      min-width: 100%; 
      min-height: 100%;
      max-height: 272px;
      max-width : 272px;    
    `};
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    vertical-align : middle;
    object-fit: cover;
`

const SearchBrandProdItemTitlePBlock = styled.p`
    ${isMobileOnly&&`
      width:46vw;
      height:38px;
    `};
    /* max-height: 38px;
    line-height: 1.4;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis; */
    cursor: pointer;
`;

/* const SearchBrandProdItemBrandSpanBlock = styled.span`
    display: ${props => props.display};
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
`; */

const SearchBrandProdItem = ({ img, prodname, sale_price, prdct_price, onClick, prdct_id}) => {

    const [clientXonMouseDown, setClientXonMouseDown] = useState(null);
    const [clientYonMouseDown, setCclientYonMouseDown] = useState(null);

    const handleOnMouseDown = (e) => {
        setClientXonMouseDown(e.clientX);
        setCclientYonMouseDown(e.clientY);
        e.preventDefault() // stops weird link dragging effect
      }

    const handleOnClick = (e) => {
        e.stopPropagation()
        if (clientXonMouseDown !== e.clientX ||
            clientYonMouseDown !== e.clientY) {
          // prevent link click if the element was dragged
          e.preventDefault()
        }
        else{
            //onClick();
        }
      }

    // console.log("brandname : " + brandname);
    return (
        <SearchBrandProdItemBlock  style={isMobileOnly?{}:{ width: '301px', paddingLeft: "29px" }}
        /* onMouseDown = {handleOnMouseDown} onClick = {handleOnClick} */>
        <Link to={"/prod?prodid="+prdct_id} onMouseDown = {handleOnMouseDown} onClick = {handleOnClick}>
            <SearchBrandProdItemPBlock>
                <SearchBrandProdItemImg src={img} style={{display: 'inline-block'}}/>
            </SearchBrandProdItemPBlock>

            <SearchBrandProdItemTitlePBlock className = "product_title">
                {prodname}
            </SearchBrandProdItemTitlePBlock>
          {F.showAmount({
            prefix: "견적시작가 ",
            pfFontSize: "12px",
            pfWeight: "400",
            fontSize: "18px",
            amount: sale_price,
            weight: "500",
            unit:""
          })}
            {/*<SpanPrice value={sale_price} isSale={false} />*/}
            {/*{*/}
            {/*    sale_price === prdct_price ? '' :*/}
            {/*        <SpanPrice value={prdct_price} isSale={true} />*/}
            {/*}*/}
            </Link>
        </SearchBrandProdItemBlock>
    );
};

export default SearchBrandProdItem;
